import request from '@/utils/request'

export function fetchList(query) {
  return request({
    url: '/contact/contacts',
    method: 'get',
    params: query
  })
}

export function createContact(data) {
  return request({
    url: '/contact/contacts',
    method: 'post',
    data
  })
}

export function fetchContact(id) {
  return request({
    url: '/contact/contact/' + id,
    method: 'get'
  })
}

export function updateContact(id, data) {
  return request({
    url: '/contact/contact/' + id,
    method: 'patch',
    data
  })
}

export function deleteContact(id) {
  return request({
    url: '/contact/contact/' + id,
    method: 'delete'
  })
}

export function fetchContactCustomerList(id) {
  return request({
    url: '/contact/contact/' + id + '/customers',
    method: 'get'
  })
}

export function updateContactCustomerList(id, data) {
  return request({
    url: '/contact/contact/' + id + '/customers',
    method: 'post',
    data
  })
}

export function fetchAllContacts() {
  return request({
    url: '/contact/get-contact-list',
    method: 'get',
  })
}

export function fetchOwnerContacts() {
  return request({
    url: '/contact/owner-contacts',
    method: 'get',
  })
}

export function fetchUserContacts(id) {
  return request({
    url: '/contact/user-contacts/' + id,
    method: 'get',
  })
}

export function updateUserContacts(id, data) {
  return request({
    url: '/contact/user-contacts/' + id,
    method: 'post',
    data
  })
}

export function CheckContact(data) {
  return request({
    url: '/contact/check',
    method: 'post',
    data
  })
}